module.exports = __webpack_public_path__ + "img/safety-pathway.3675d685.jpg";